import { render, staticRenderFns } from "./recommendDetailDia.vue?vue&type=template&id=152802ec&scoped=true"
import script from "./recommendDetailDia.vue?vue&type=script&lang=js"
export * from "./recommendDetailDia.vue?vue&type=script&lang=js"
import style0 from "./recommendDetailDia.vue?vue&type=style&index=0&id=152802ec&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "152802ec",
  null
  
)

export default component.exports